import { createSlice } from "@reduxjs/toolkit";
import { IThresholdCrossingDeviceFilterState } from "../types";
import { initialGeoRegion } from "../../../components/helpers";
import {
    setGeoRegionAction,
    setProfileKeyAction,
    setIsThresholdCrossingDeviceAssociationProgressAction,
    setSiteGroupAction,
    setAddDeviceGeoRegionAction,
    setAddDeviceSiteGroupAction,
    setIsAssociatedDevicesRemovedAction,
    resetFiltersAction,
    resetAddDeviceFiltersAction,
    setRuleNameAction,
    setNetworkTypeAction,
    setThresholdStateAction,
    resetThresholdAlertFiltersAction
} from "./ThresholdCrossingDeviceFilterActions";

const initialState: IThresholdCrossingDeviceFilterState = {
    profileKey: "",
    isThresholdCrossingDeviceAssociationProgress: false,
    thresholdState: "ALL",
    geoRegion: initialGeoRegion,
    addDeviceGeoRegion: initialGeoRegion,
    siteGroup: ""
};

const ThresholdCrossingDeviceFilterSlice = createSlice({
    name: "thresholdCrossingDeviceFilter",
    initialState,
    reducers: {
        setProfileKey: setProfileKeyAction,
        setIsThresholdCrossingDeviceAssociationProgress: setIsThresholdCrossingDeviceAssociationProgressAction,
        setSiteGroup: setSiteGroupAction,
        setAddDeviceSiteGroup: setAddDeviceSiteGroupAction,
        setGeoRegion: setGeoRegionAction,
        setAddDeviceGeoRegion: setAddDeviceGeoRegionAction,
        setIsAssociatedDevicesRemoved: setIsAssociatedDevicesRemovedAction,
        setResetFilters: resetFiltersAction,
        setResetAddDeviceFilters: resetAddDeviceFiltersAction,
        setRuleName:setRuleNameAction,
        setNetworkType: setNetworkTypeAction,
        setThresholdState: setThresholdStateAction,
        setThresholdAlertResetFilters: resetThresholdAlertFiltersAction
    },
});

export const ThresholdCrossingDeviceFilterReducer = ThresholdCrossingDeviceFilterSlice.reducer;
export const {
    setProfileKey,
    setIsThresholdCrossingDeviceAssociationProgress,
    setSiteGroup,
    setAddDeviceSiteGroup,
    setGeoRegion,
    setAddDeviceGeoRegion,
    setIsAssociatedDevicesRemoved,
    setResetFilters,
    setResetAddDeviceFilters,
    setRuleName,
    setNetworkType,
    setThresholdState,
    setThresholdAlertResetFilters
} = ThresholdCrossingDeviceFilterSlice.actions; 